import { PageController } from '@client/components/_core/layout/PageController';
import { ContactEdit } from '@client/components/contacts/ContactEdit';
import { SupplierContactDetails } from '@client/components/contacts/SupplierContactDetails';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { CONTACT_TYPES } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import { z } from 'zod';
import { claimFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/claims/details/$id/contacts/edit/$contactId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit contact',
        },
    },
    params: {
        parse({ contactId }) {
            return { contactId: BigInt(contactId) };
        },
    },
    validateSearch: zodValidator(
        z.object({
            type: z.enum(CONTACT_TYPES).catch('POLICY_HOLDER'),
        }),
    ),
    component: RouteComponent,
});

function RouteComponent() {
    const isReadonly = claimFormStore.use.isReadonly();
    const { id, contactId } = Route.useParams();
    const { type } = Route.useSearch();
    const navigate = useNavigate();

    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    // Vulnerability indicator now surfaces as an icon-with-popover in the
    // contact-list row (`ContactTable.columns.tsx → isPrimary` cell) rather
    // than as a banner here. Keeping the signal row-scoped means it
    // travels with the right contact instead of consuming vertical space
    // above the edit form.
    return (
        <PageController route={Route}>
            {type === 'SUPPLIER' ? (
                <SupplierContactDetails contactId={contactId} />
            ) : (
                <ContactEdit action={['edit', contactId]} type={type} entity="claim" entityId={id} />
            )}
        </PageController>
    );
}
